import register from "common/bindings/registerBinding";

/** This adds some special versions of the value binding if a particular widget needs extra handling. */

/**
 * This binding patches an issue with the drop down list cascadeFrom functionality.
 * Basically, the value needs to be reset after the parent drop down cascades, in order to ensure that it is set properly.
 */
const combobox = register.widget("combobox", "value", kendo.data.binders.widget.value.extend({
    init: function() {
        kendo.data.binders.widget.value.fn.init.apply(this, arguments);

        var me = this;
        if (this.widget.options.cascadeFrom) {
            var parent = kendo.widgetInstance($("#" + this.widget.options.cascadeFrom));
            parent.bind("cascade", function() {
                me.refresh();
            });
        }
    }
}));

const dfdropdownlist = register.widget("dfdropdownlist", "value", combobox.extend({
    init: function() {
        kendo.data.binders.widget.combobox.value.fn.init.apply(this, arguments);
        var me = this;
        this.widget.bind("dataBound", function() {
            if (me.bindings.value.get() !== me.widget.value()) {
                me.refresh();
            }
        });

    }
}));

register.widget("datasourcepicker", "value", dfdropdownlist);

register.widget("dfgrid", "value", kendo.data.binders.widget.value.extend({
    init: function() {
        kendo.data.binders.widget.value.fn.init.apply(this, arguments);
        var me = this;
        this.widget.bind("dataBound", function() {
            me.refresh();
            if (!me.widget.value()) {
                me.bindings.value.set(null);
            }
        });
    }
}));

register.widget("dflistview", "value", kendo.data.binders.widget.value.extend({
    init: function() {
        kendo.data.binders.widget.value.fn.init.apply(this, arguments);
        var me = this;
        this.widget.bind("dataBound", function() {
            me.refresh();
            if (!me.widget.value()) {
                me.bindings.value.set(null);
            }
        });
    }
}));
